export default {
  emails: [],
  emailsCount: 0
};
